var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3572 1.14003C15.3572 1.14003 14.0077 1.93719 13.2573 2.16323C12.8546 1.70012 12.3193 1.37188 11.7239 1.2229C11.1285 1.07393 10.5017 1.1114 9.9283 1.33026C9.35489 1.54911 8.86254 1.93879 8.51782 2.44659C8.1731 2.95439 7.99265 3.55581 8.00088 4.1695V4.83826C6.82563 4.86874 5.66108 4.60808 4.61095 4.07952C3.56082 3.55095 2.65771 2.77089 1.98205 1.80878C1.98205 1.80878 -0.692987 7.82762 5.32584 10.5027C3.94855 11.4376 2.30784 11.9063 0.644531 11.8402C6.66336 15.184 14.0197 11.8402 14.0197 4.14944C14.0193 3.96308 14.0014 3.77806 13.9662 3.59437C14.6483 2.9216 15.3572 1.14003 15.3572 1.14003Z",
    stroke: "#222222",
    strokeWidth: 1.00314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.77ef7a210991595f02e09e949199b753.svg";
export { ForwardRef as ReactComponent };